import {
  UkvVehicleDataQuery,
  getUkvData,
  getUkvError,
  getUkvHasError,
  getUkvVrm,
  getUkvAdditionalQueryVariables,
} from 'SharedQueries/UkvVehicleData';
import {
  GovVehicleDataQuery,
  getMOTData,
  getMOTError,
  getMOTHasError,
  getMOTVrm,
  getMOTAdditionalQueryVariables,
} from 'SharedQueries/GovVehicleData';

const VALID_QUERY_TYPES = ['ukv', 'mot,tax'];

/**
 * A function that takes a query type and returns the corresponding query functions.
 *
 * @param {string} queryType - The type of query to use. Valid types are 'ukv' and 'mot'.
 * @returns {Object} An object containing the query functions for the specified query type.
 * @throws {Error} Throws an error if the query type is invalid.
 */
export const useVehicleQuery = (queryType) => {
  if (!VALID_QUERY_TYPES.includes(queryType)) {
    throw new Error(
      `Invalid query type: ${queryType}. Valid types are: ${VALID_QUERY_TYPES.join(', ')}`,
    );
  }
  switch (queryType) {
    case 'ukv':
      return {
        query: UkvVehicleDataQuery,
        getData: getUkvData,
        getError: getUkvError,
        getHasError: getUkvHasError,
        getVrm: getUkvVrm,
        getAdditionalQueryVariables: getUkvAdditionalQueryVariables,
      };
    case 'mot,tax':
      return {
        query: GovVehicleDataQuery,
        getData: getMOTData,
        getError: getMOTError,
        getHasError: getMOTHasError,
        getVrm: getMOTVrm,
        getAdditionalQueryVariables: getMOTAdditionalQueryVariables,
      };
    default:
      throw new Error(`Invalid query type: ${queryType}`);
  }
};
